import { useState, forwardRef, useEffect } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Info from "./Info";
import Register from "./Register";
import Success from "./Success";
import Status from "./Status";

import request from "../../../../../utilities/requests";
import { toast } from "../../../../../utilities/SnackBarUtils";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Main = ({ open, close, refreshProfiles }) => {
  const [loading, setLoading] = useState(true);
  const [registered, setRegistered] = useState(false);
  const [screen, setScreen] = useState(null);

  useEffect(() => {
    if (open) {
      checkRegistration();
    }
  }, [open]);

  const checkRegistration = async () => {
    const result = await request("skillswap/status");
    if (result.success) {
      if (result.registered) {
        setScreen("status");
      } else {
        setScreen("info");
      }
      setRegistered(true);
    } else {
      toast.error(result.error);
      setScreen("info");
    }
    setLoading(false);
  };

  const handleRegister = async () => {
    const result = await request("skillswap/register", "post", {});
    if (result.success) {
      setScreen("success");
      refreshProfiles();
    } else {
      toast.error(result.error);
    }
  };

  const handleRemove = async () => {
    const result = await request("skillswap/remove", "post", {});
    if (result.success) {
      refreshProfiles();
      close();
      toast.success("You have been removed from Skill Swap")
    } else {
      toast.error(result.error);
    }
  };

  const renderScreen = () => {
    if (loading) {
      return (
        <div
          style={{
            height: "500px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={60} />
        </div>
      );
    }

    if (!screen || screen === "info") {
      return <Info close={close} register={() => setScreen("register")} />;
    } else if (screen === "register") {
      return <Register close={close} register={handleRegister} />;
    } else if (screen === "success") {
      return <Success close={close} />;
    } else if (screen === "status") {
      return <Status close={close} unenroll={handleRemove}/>
    }

    if (!screen) return null;
  };

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={close}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={close}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Skill Swap
          </Typography>
          {/* <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button> */}
        </Toolbar>
      </AppBar>
      {renderScreen()}
    </Dialog>
  );
};

export default Main;
